import './CommercialBanner.css';
import commercialBg from '../../assets/commercial_banner_bg.png';

const features = [
  {
    title: 'Custom Battery Storage Systems',
    desc: 'Tailored systems to improve efficiency, reduce reliance on the grid, and control energy costs.',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <rect x="7" y="3" width="10" height="18" rx="2" stroke="#eaff50" strokeWidth="1.8" />
        <line x1="10" y1="1" x2="14" y2="1" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="12" y1="9" x2="12" y2="15" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="9" y1="12" x2="15" y2="12" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: 'Book a Site Assessment',
    desc: 'Our experts will assess your energy needs and recommend the right battery solution.',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <rect x="5" y="3" width="14" height="18" rx="2" stroke="#eaff50" strokeWidth="1.8" />
        <line x1="9" y1="8" x2="15" y2="8" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="9" y1="12" x2="15" y2="12" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="9" y1="16" x2="12" y2="16" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: 'Maximise Savings',
    desc: 'Reduce peak demand charges and operational costs with smart energy storage.',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="#eaff50" strokeWidth="1.8" />
        <path d="M12 7v1.5M12 15.5V17M9.5 9.8A2.5 2.5 0 0 1 12 8.5a2.5 2.5 0 0 1 0 5c-1.38 0-2.5.9-2.5 2" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: 'Every Dollar Saved Adds Up',
    desc: 'Every dollar saved on energy goes straight back to your business.',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <polyline points="16 7 22 7 22 13" stroke="#eaff50" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

export default function CommercialBanner() {
  return (
    <section className="cbanner" style={{ backgroundImage: `url(${commercialBg})` }}>
      <div className="cbanner-overlay" />
      <div className="cbanner-inner">

        {/* Left */}
        <div className="cbanner-left">
          <div className="cbanner-tag">
            <div className="cbanner-tag-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M13 2L4.09 12.11A1 1 0 0 0 5 14h6l-1 8 8.91-10.11A1 1 0 0 0 18 10h-6l1-8z" fill="#eaff50" />
              </svg>
            </div>
            <span className="cbanner-tag-text">Power. Stored. Smarter Business.</span>
          </div>
          <h1 className="cbanner-title">Commercial Solar &amp; Battery Solutions</h1>
          <div className="cbanner-underline" />
          <p className="cbanner-desc">
            Custom battery storage systems designed to help Australian businesses improve energy efficiency, reduce reliance on the grid, and gain greater control over long-term energy costs.
          </p>
        </div>

        {/* Center — empty, background shows through */}
        <div className="cbanner-center" />

        {/* Right features */}
        <div className="cbanner-right">
          {features.map((f, i) => (
            <div key={i} className="cbanner-feature">
              <div className="cbanner-feature-icon">{f.icon}</div>
              <div className="cbanner-feature-text">
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
